import { ProjectCollateralCategory } from '../../_project_types/projectCollateralCategory'

export const bgColorClassNamesByCollateralCategory = {
  [ProjectCollateralCategory.Commercial]: 'bg-[#7A5200]',
  [ProjectCollateralCategory.Land]: 'bg-[#297A00]',
  [ProjectCollateralCategory.Other]: 'bg-[#3D007A]',
  [ProjectCollateralCategory.Recreational]: 'bg-[#00387A]',
  [ProjectCollateralCategory.Residential]: 'bg-[#7A0014]',
}
